import React, { useRef, useState, useEffect } from "react";
import './index.scss';
import { connect } from 'react-redux'
import { setMapReferenceThreeD } from "../../action/map-reference-actions";
import Render3dMarkers from "./render-3d-markers";
import Render3dPhotos from "./render-3d-photos";
import Render3dLine from "./render-3d-line";
import Render3dPolygons from "./render-3d-polygons";
import Render3dTracks from "./render-3d-tracks";
import RenderCircles3D from "./render-3d-circle";

const zoomToRange = (zoom) => {
  return 591657550.5 / Math.pow(2, zoom); // in meters
};

const zoomToRangeMap = {
  2: 20000000,
  3: 10000000,
  4: 5000000,
  5: 2500000,
  6: 1250000,
  7: 650000,
  8: 325000,
  9: 162000,
  10: 81000,
  11: 40000,
  12: 20000,
  13: 10000,
  14: 5000,
  15: 2500,
  16: 1250,
  17: 700,
  18: 350,
  19: 175,
  20: 90,
};

const Google3DMap = (props) => {
  const [mapInstance, setMapInstance] = useState(null);
  const [mapCenter, setMapCenter] = useState(props.mapReference.getCenter?.());
  const mapref = useRef(null); // ✅ persistent reference

  const load3DScript = () => {
    return new Promise((resolve, reject) => {
      if (props.mapReference) return resolve();

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyC3cOx382EeNm0asyx_onfHu6xFL_IZpCo&libraries=maps,maps3d,marker&v=beta`;
      script.async = true;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  useEffect(() => {
    (async () => {
      await load3DScript();
      const { Map3DElement } = await window.google.maps.importLibrary("maps3d");
      let zoom = props.mapReference.getZoom()
      // const range = zoomToRange(zoom); // use this in Map3DElement config
      const range = zoomToRangeMap[zoom] ?? 10000; // Fallback value

      const map = new Map3DElement({
        center: {
          lat: mapCenter?.lat() ? mapCenter.lat() : 41.6171,
          lng: mapCenter?.lng() ? mapCenter.lng() : -100.7122,
          altitude: 2322,
        },
        // range: 5041134,
        // tilt: 18,
        range,
        tilt: 0,
        heading: 2,
        mode: "HYBRID",
      });

      mapref.current = map; // ✅ store in ref
      document.getElementById("3dmap-container").appendChild(map);
      setMapInstance(map);
      props.setMapReferenceThreeD(map);

      const container = document.getElementById("3dmap-container");
      const observer = new MutationObserver(() => {
        const gmpMap = container.querySelector("gmp-map-3d");
        if (gmpMap?.shadowRoot) {
          const cameraControl = gmpMap.shadowRoot.querySelector(
            "gmp-internal-map-3d-camera-control"
          );
          if (cameraControl) {
            cameraControl.style.bottom = "40px";
            observer.disconnect();
          }
        }
      });

      observer.observe(container, { childList: true, subtree: true });

      setTimeout(() => {
        props.load3dMap?.();
      }, 5000);
    })();
  }, []);

  return (
    <div id="3dmap-container" className="three-d-map">
      <Render3dMarkers mapReferenceThreed={mapInstance} />
      <Render3dPhotos mapReferenceThreed={mapInstance} />
      <Render3dLine mapReferenceThreed={mapInstance} />
      <Render3dPolygons mapReferenceThreed={mapInstance} />
      <Render3dTracks mapReferenceThreed={mapInstance} />
      <RenderCircles3D mapReferenceThreed={mapInstance} />
    </div>
  );
};


const mapStateToProps = state => ({
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  markers: state.markers,
  photos: state.photos,
  polygons: state.polygons,
  mapReferenceThreeD: typeof state.mapReferenceThreeD === 'function' ? state.mapReferenceThreeD() : null,
})

const mapDispatchToProps = dispatch => ({
  setMapReferenceThreeD: (payload) => dispatch(setMapReferenceThreeD(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(Google3DMap)

